import Index from "../views/home/Index.vue";
import NormalPgae from "../views/normalPage/NormalPage.vue";
import Download from "../views/download/Index.vue";
import PrivacyTerms from "../views/privacyTerms/PrivacyTerms.vue";
import PrivacyService from "../views/privacyService/PrivacyService.vue";
import UserAgreement from "../views/userAgreement/UserAgreement.vue";
import AffiliatePolicy from "../views/affiliatePolicy/Index.vue";
import AboutUS from "../views/aboutUs/AboutUs.vue";
import FAQ from "../views/faq/FAQ.vue";
import AffiliateProgram from "../views/affiliateProgram/Index.vue";
import BecomeAnAffiliate from "../views/becomeAnAffiliate/Index.vue";
import ForgotPassword from "../views/forgotpwd/forgotPwd/ForgotPwd.vue";
import Verify from "../views/verify/Index.vue";
import ResetPassword from "../views/resetPassword/ResetPassword.vue";
import UserCenter from "../views/userCenter/Index.vue";
import Dashboard from "../views/dashboard/Index.vue";
import Settings from "../views/settings/Settings.vue";
import Affiliate from "../views/affiliate/Index.vue";
import Recharge from "../views/rechargeRecord/RechargeRecord.vue";
import DeviceManagement from "../views/deviceManagement/deviceManagement.vue";
import Commission from "../views/commission/Index.vue";
import WithdrawDetails from "../views/withdrawDetails/Index.vue";
import Notification from "../views/notification/Notification.vue";
import LoginRegister from "../views/auth/loginRegister/LoginRegister.vue";
import Login from "../views/auth/login/Login.vue";
import Register from "../views/auth/register/Register.vue";
import Redirect from "../views/redirect/Redirect.vue";
import iosReach from "../views/landingPage/iosReach/Index.vue";
import AppPrivacyTerms from "../views/app/PrivacyTerms.vue";
import AppAutoRenewalAgreement from "../views/app/autoRenewalAgreement/AutoRenewalAgreement.vue";
import PauseServe from "../views/pauseServe/Index.vue";
import SubscribeManage from "../views/subscribeManage/subscribeManage.vue";
import RewardRules from "../views/app/rewardRules/rewardRules.vue";
import LineDescFAQ from "../views/app/lineDescFAQ/lineDescFAQ.vue";
import VpnPermissionDeniedFAQ from "../views/app/vpnPermissionDeniedFAQ/vpnPermissionDeniedFaq.vue";
import PromotionQt from "../views/promotion/lp/Qt.vue";
import PromotionApp from "../views/promotion/lp/App.vue";
import PromotionTv from "../views/promotion/lp/Tv.vue";
import PromotionNetflix from "../views/promotion/Netflix/Netflix.vue";
import PromotionBbc from "../views/promotion/Bbc/Bbc.vue";
import PromotionStreamMedia from "../views/promotion/StreamMedia/StreamMedia.vue";
import Company from "../views/company/company.vue";
import RegionTutorialIOS from "../views/regionTutorialIOS/regionTutorialIOS.vue";
import DownloadGuideIos from "../views/downloadGuideIos/downloadGuideIos.vue";
import RewardRulesWeb from "../views/rewardRules/rewardRules.vue";
import DeleteAccount from "../views/deleteAccount/index.vue";

export default [
  { path: "/", component: Index, meta: { scrollToTop: true } },
  {
    path: "/delete-account",
    component: DeleteAccount,
    meta: { scrollToTop: true },
  },
  {
    path: "/normal-page",
    component: NormalPgae,
    children: [
      { path: "/download", component: Download, meta: { scrollToTop: true } },
      {
        path: "/privacy-terms",
        component: PrivacyTerms,
        meta: { scrollToTop: true },
      },
      {
        path: "/privacy-service",
        component: PrivacyService,
        meta: { scrollToTop: true },
      },
      {
        path: "/user-agreement",
        component: UserAgreement,
        meta: { scrollToTop: true },
      },
      {
        path: "/affiliate-policy",
        component: AffiliatePolicy,
        meta: { scrollToTop: true },
      },
      { path: "/about", component: AboutUS, meta: { scrollToTop: true } },
      {
        path: "/affiliate-program",
        component: AffiliateProgram,
        meta: { scrollToTop: true },
      },
      {
        path: "/become-an-affiliate",
        component: BecomeAnAffiliate,
        meta: { scrollToTop: true },
      },
      {
        path: "/forgotpw",
        component: ForgotPassword,
        meta: { scrollToTop: true },
      },
      { path: "/verify-email", component: Verify, meta: { scrollToTop: true } },
      {
        path: "/reset-password",
        component: ResetPassword,
        meta: { scrollToTop: true },
      },
      { path: "/ios-reach", component: iosReach },
      { path: "/unsubscribe", component: SubscribeManage },
      { path: "/company", component: Company },
      { path: "/region-tutorial-iOS", component: RegionTutorialIOS },
      { path: "/download-guide-ios", component: DownloadGuideIos },
      { path: "/reward-rules", component: RewardRulesWeb },
    ],
  },
  {
    path: "/usercenter",
    component: UserCenter,
    children: [
      {
        path: "/dashboard",
        component: Dashboard,
        linkActiveClass: "active-link",
        meta: { scrollToTop: true },
      },
      {
        path: "/settings",
        component: Settings,
        linkActiveClass: "active-link",
        meta: { scrollToTop: true },
      },
      {
        path: "/affiliate",
        component: Affiliate,
        linkActiveClass: "active-link",
        meta: { scrollToTop: true },
      },
      {
        path: "/recharge",
        component: Recharge,
        linkActiveClass: "active-link",
        meta: { scrollToTop: true },
      },
      {
        path: "/device-management",
        component: DeviceManagement,
        linkActiveClass: "active-link",
        meta: { scrollToTop: true },
      },
      {
        path: "/commission",
        component: Commission,
        linkActiveClass: "active-link",
        meta: { scrollToTop: true },
      },
      {
        path: "/commission/withdraw-details",
        component: WithdrawDetails,
        linkActiveClass: "active-link",
        meta: { scrollToTop: true },
      },
      {
        path: "/notification",
        component: Notification,
        linkActiveClass: "active-link",
        meta: { scrollToTop: true },
      },
    ],
  },
  { path: "/faq", component: FAQ, meta: { scrollToTop: true } },
  {
    path: "/loginRegister",
    component: LoginRegister,
    children: [
      {
        path: "/login",
        component: Login,
        linkActiveClass: "login-register-tab",
        meta: { scrollToTop: true },
      },
      {
        path: "/register",
        component: Register,
        linkActiveClass: "login-register-tab",
        meta: { scrollToTop: true },
      },
    ],
  },
  { path: "/redirect", component: Redirect },
  {
    path: "/app/privacy-terms",
    component: AppPrivacyTerms,
    meta: { scrollToTop: true },
  },
  {
    path: "/app/auto-renewal-agreement",
    component: AppAutoRenewalAgreement,
    meta: { scrollToTop: true },
  },
  {
    path: "/app/reward-rules",
    component: RewardRules,
    meta: { scrollToTop: true },
  },
  {
    path: "/app/line-desc-faq",
    component: LineDescFAQ,
    meta: { scrollToTop: true },
  },
  {
    path: "/app/vpn-permission-denied-faq",
    component: VpnPermissionDeniedFAQ,
    meta: { scrollToTop: true },
  },
  { path: "/pause-serve", component: PauseServe, meta: { scrollToTop: true } },
  {
    path: "/promotion/qt",
    component: PromotionQt,
    meta: { scrollToTop: true },
  },
  {
    path: "/promotion/app",
    component: PromotionApp,
    meta: { scrollToTop: true },
  },
  {
    path: "/promotion/tv",
    component: PromotionTv,
    meta: { scrollToTop: true },
  },
  {
    path: "/promotion/netflix",
    component: PromotionNetflix,
    meta: { scrollToTop: true },
  },
  {
    path: "/promotion/bbc",
    component: PromotionBbc,
    meta: { scrollToTop: true },
  },
  {
    path: "/promotion/streamMedia",
    component: PromotionStreamMedia,
    meta: { scrollToTop: true },
  },
  { path: "/*", redirect: "/" },
];



// WEBPACK FOOTER //
// ./src/config/routes.js